module.exports = __webpack_public_path__ + "img/7.f208142b.gif";